export const searchRandom='https://www.themealdb.com/api/json/v1/1/random.php'

export const listCategories='https://www.themealdb.com/api/json/v1/1/list.php?c=list'
export const listAreas='https://www.themealdb.com/api/json/v1/1/list.php?a=list'
export const listIngredients='https://www.themealdb.com/api/json/v1/1/list.php?i=list'

export const filterCategory='https://www.themealdb.com/api/json/v1/1/filter.php?c='// + category
export const filterArea='https://www.themealdb.com/api/json/v1/1/filter.php?a='// + area
export const filterIngredient='https://www.themealdb.com/api/json/v1/1/filter.php?i='// + ingredient

export const searchID='https://www.themealdb.com/api/json/v1/1/lookup.php?i='// + id

export const searchName='https://www.themealdb.com/api/json/v1/1/search.php?s='// + name

